import { configureStore } from '@reduxjs/toolkit';
import { businessPlanReducer } from '../businessplan/businessPlanSlice';
import { onboardingReducer } from '../onboarding/onboardingSlice';

export const store = configureStore({
  reducer: {
    businessPlan: businessPlanReducer,
    onboarding: onboardingReducer,
  },
});

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
